import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {
    Route
} from 'react-router-dom';
import {Switch} from "react-router";
import moment from 'moment';
import './css/bootstrap.css';
import './css/cryptocoins.css';
import './css/cryptocolors.css';
import './App.css';
import API from './API';
import TopMenu from "./TopMenu";
import CoinDetails from "./CoinDetails";
import ViewState from "./ViewState";
import Footer from "./Footer";
import NotFound from "./NotFound";
import CoinList from "./CoinList";
import About from "./About";
import CoinTopList from "./CoinTopList";
import Settings from "./Settings";

@observer
class App extends Component {
    constructor(props) {
        super(props);

        const coins = this.props.appState.coins || [];
        this.state = {updateTimer: 0, isHidden: false, coins: coins, lastUpdate: null};
        this.updateCoins = this.updateCoins.bind(this);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
        this.props.appState.updateCoins = this.updateCoins;
    }

    async updateCoins() {
        if (this.state.isHidden) {
            return;
        }

        if (this.state.lastUpdate) {
            let now = moment(new Date());
            let end = moment(this.state.lastUpdate);
            let duration = moment.duration(now.diff(end));
            let seconds = duration.asSeconds();
            if (seconds < 20) {
                return;
            }
        }

        let appState = this.props.appState;
        switch (appState.viewState) {
            case ViewState.table:
                let coins = await API.updateCoins(appState);
                this.setState({
                    coins,
                    lastUpdate: new Date()
                });
                break;
            case ViewState.detail:
                API.getCoin(appState);
                break;
            default:
                break;
        }
    }

    handleVisibilityChange(visibilityState, documentHidden) {
        //if (documentHidden !== this.state.isHidden) {
            this.setState({isHidden: documentHidden});
            if (!documentHidden) {
                this.updateCoins();
            }
        //}
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !nextState.isHidden;
    }

    componentWillMount() {
        API.updateCurrencies(this.props.appState);
    }

    componentDidMount() {
        let intervalId = setInterval(this.updateCoins, 62000);
        this.setState({
            updateTimer: intervalId
        })
    }

    componentWillUnmount() {
        if (this.state.updateTimer) {
            clearInterval(this.state.updateTimer);
        }
    }

    render() {
        return (
            <div>
                <TopMenu
                    {...this.props}
                    handleVisibilityChange={this.handleVisibilityChange}
                    updateCoins={this.updateCoins}
                />
                <div className={'app ' + this.props.appState.viewState}>
                    <div className="cg-coin-content row">
                        <Switch>
                            <Route exact
                                   path="/"
                                   render={(props) => (
                                       <CoinList coins={this.state.coins} {...props} {...this.props} />
                                   )}
                            />

                            <Route path="/coin/:symbol"
                                   render={(props) => (
                                       <CoinDetails {...props} {...this.props} />
                                   )}
                            />

                            <Route path="/toplists"
                                   render={(props) => (
                                       <CoinTopList coins={this.state.coins} {...props} {...this.props} />
                                   )}
                            />

                            <Route path="/settings"
                                   render={(props) => (
                                       <Settings {...this.props} />
                                   )}
                            />

                            <Route path="/about"
                                   render={(props) => (
                                       <About {...this.props} />
                                   )}
                            />
                            <Route component={NotFound}/>
                        </Switch>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js